// components/SearchModal.tsx
"use client";
import { useEffect, useRef, useState } from "react";
import styles from "./SearchModal.module.css";
// import MainFilterSearchBox from "../hero/hero-1/MainFilterSearchBox";
import MainFilterSearchBox from "@/components/hotel-listing-v2/ui/SearchBar/MainFilterSearchBox";
import { usePathname } from "next/navigation";
interface SearchModalProps {
    isOpen: boolean;
    setIsOpen: (isOpen: boolean) => void;
  }

const SearchModal: React.FC<SearchModalProps> = ({ isOpen, setIsOpen }) => {
  const locationInputRef = useRef<HTMLInputElement>(null);
  const pathname = usePathname();
  useEffect(() => {
    if (isOpen) {
      // Blur any active element to prevent iOS auto-focus
      const activeElement = document.activeElement;
      if (activeElement instanceof HTMLInputElement || activeElement instanceof HTMLTextAreaElement) {
        activeElement.blur();
      }
      document.body.style.overflow = "hidden";
      // Focus the Location input after a slight delay to ensure DOM is ready
      setTimeout(() => {
        locationInputRef.current?.focus();
      }, 100);

      // Debug focus changes
      const handleFocus = (e: FocusEvent) => {
        console.log("Focused element:", e.target);
      };
      document.addEventListener("focusin", handleFocus);
      return () => {
        document.removeEventListener("focusin", handleFocus);
      };
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [isOpen]);
  
  // Separate useEffect to handle route changes
  useEffect(() => {
    // Close modal and reset overflow on pathname change
    document.body.style.overflow = "";
  }, [pathname, isOpen]); // Depend on pathname and setIsOpen
  return (
    <>
      {isOpen && (
        <div className={`${styles.modalOverlay} d-flex justify-content-left`}>
          <div className={`${styles.modalContent} card w-100 position-relative`}>
          <div className={`${styles.header} d-flex justify-content-between align-items-center p-3 p-md-4`}>
            {/* Close Button */}
            <h3 className={styles.headerTitle}>Search</h3>
            <button
              className={`${styles.closeButton} btn btn-link position-absolute`}
              onClick={() => setIsOpen(false)}
              aria-label="Close"
            >
              <svg width="20" height="20" viewBox="0 0 15 15" fill="none">
                <path
                  d="M1.707.293A1 1 0 0 0 .293 1.707l5.43 5.431-5.43 5.431a1 1 0 1 0 1.414 1.414l5.431-5.43 5.431 5.43a1 1 0 0 0 1.414-1.414l-5.43-5.43 5.43-5.432A1 1 0 0 0 12.57.293l-5.43 5.43L1.706.294Z"
                  fill="#141414"
                />
              </svg>
            </button>
            </div>

           {/* Main Content */}
              <div className={styles.contentWrapper}>
                <MainFilterSearchBox requestFrom="home" />
              </div>
          </div>
        </div>
      )}
    </>
  );
};

export default SearchModal;